const Link = {
    baseStyle: {
        _focus: {
            boxShadow: 'none',
        },
        textDecoration: 'underline',
    },
    defaultProps: {},
};
export default Link;
